import {
  AppBar,
  Toolbar,
  Grid,
  Typography,
  IconButton
} from '@material-ui/core'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'
import AccountCircleOutlineIcon from 'mdi-react/AccountCircleOutlineIcon'
import AccountGroupOutlineIcon from 'mdi-react/AccountGroupOutlineIcon'
import CalendarMonthOutlineIcon from 'mdi-react/CalendarMonthOutlineIcon'
import HomeCityOutlineIcon from 'mdi-react/HomeCityOutlineIcon'
import MessageIcon from 'mdi-react/MessageIcon'
import { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { NavLanguageForm, DesktopMenu, NavDrawer } from '.'
import { ReactComponent as MenuBarIcon } from '../../../images/navigation/MenuBarIcon.svg'
import { isSmallScreen, getIsTinyScreen } from '../../../libs/screenSize'
import { MuiClasses } from '../../../types'
import { isNumStep } from '../../../utils/apartments'
import { TalkUser, initialize } from '../../../utils/talkChat'
import { BaseNavMenuProps, NavMenuActionProps } from '../types'
//import NavBarPhoneNumber from './NavBarPhoneNumber'
//import LeeaLogo from '../../../images/LeeaLogo.svg'
import phoneIcon from '../../../images/phoneIcon.png'

const navItems = [
  {
    id: '/overview',
    label: 'navigation.apartments',
    icon: HomeCityOutlineIcon
  },
  {
    id: '/applications',
    label: 'navigation.applicants',
    icon: AccountGroupOutlineIcon
  },
  {
    id: '/messages',
    label: 'navigation.messages',
    icon: MessageIcon
  },
  {
    id: '/showings/overview',
    label: 'navigation.calendar',
    icon: CalendarMonthOutlineIcon
  },
  {
    id: '/apartments',
    label: 'navigation.menu',
    icon: MenuBarIcon
  },
  {
    id: '/profile',
    label: 'navigation.profile',
    icon: AccountCircleOutlineIcon
  }
]

const adminUserNavItems = [
  {
    id: '/overview',
    label: 'navigation.apartments',
    icon: HomeCityOutlineIcon
  },
  {
    id: '/applications',
    label: 'navigation.applicants',
    icon: AccountGroupOutlineIcon
  },
  // {
  //   id: '/messages',
  //   label: 'navigation.messages',
  //   icon: MessageIcon
  // },
  {
    id: '/showings/overview',
    label: 'navigation.calendar',
    icon: CalendarMonthOutlineIcon
  },
  {
    id: '/adminApartments/marketing',
    label: 'navigation.menu',
    icon: MenuBarIcon
  },
  {
    id: '/profile',
    label: 'navigation.profile',
    icon: AccountCircleOutlineIcon
  }
]

interface NavBarProps {
  handleToggleDrawer: () => void
  drawerOpen: boolean
  isAuthenticated: boolean
  isAdminUser: boolean
  classes: MuiClasses
  pathname: string
  width: Breakpoint
  doNavigation: (path: string) => void
  showLanguageSwitcher: boolean
  userAttributes: any
}

const NavBar = ({
  handleToggleDrawer,
  drawerOpen,
  isAuthenticated,
  isAdminUser,
  classes,
  doNavigation,
  showLanguageSwitcher,
  pathname,
  width,
  userAttributes
}: NavBarProps) => {
  const smallScreen = isSmallScreen(width)
  const isTinyScreen = getIsTinyScreen(width)
  const currentPathEnd = pathname.includes('/showings/overview')
    ? '/showings/overview'
    : pathname.substring(pathname.lastIndexOf('/'))
  const baseNavMenuProps: BaseNavMenuProps = { classes }
  const isNewApplication = (pathname: string) =>
    pathname.split('/')[1] == 'new-application'
  const [unreadMessages, setUnreadMessages] = useState(0)
  const navMenuActionProps: NavMenuActionProps = {
    doNavigation,
    navItems: isAdminUser ? adminUserNavItems : navItems,
    currentPathEnd,
    unreadMessages: unreadMessages
  }

  const unreadMessageEvent = () => {
    if (window.talkSession) {
      setUnreadMessages(window.talkSession.unread)
      window.talkSession.unreads.on(
        'change',
        function (unreadConversations: any) {
          setUnreadMessages(unreadMessages + unreadConversations.length)
        }
      )
    }
  }

  const createChatSession = async () => {
    if (isAuthenticated && !isAdminUser && userAttributes?.email) {
      const usersFirstName = userAttributes.name.split(' ')[0]
      const talkUser: TalkUser = {
        id: userAttributes.email,
        name: usersFirstName,
        email: userAttributes.email,
        phone: userAttributes?.phone_number,
        role: isAdminUser ? 'admin' : 'owner'
      }
      await initialize(talkUser)
      unreadMessageEvent()
    }
  }

  useEffect(() => {
    ; (async () => {
      setImmediate(async () => {
        await createChatSession()
      })
    })()

    /* eslint-disable-next-line @typescript-eslint/no-empty-function */
    return () => { }
  }, [isAuthenticated, isAdminUser, userAttributes])

  return (
    <Fragment>
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.navToolbar}>
          <Grid
            className={classes.menuItems}
            container
            direction='row'
            alignItems='center'
            justify='space-between'
            style={{
              paddingRight: isNewApplication(pathname)
                ? smallScreen
                  ? '0px'
                  : '50px'
                : '0px'
            }}
          >
            <Grid item>
              <Typography className={classes.logoContainer}>
                {pathname.includes('/reserve') ||
                  pathname.includes('/create') ||
                  isNumStep(pathname, '10') ? (
                  <Typography>
                    <img
                      className={classes.logo}
                      style={{ color: '#fff', width: '100%' }}
                      src='https://fiksuvuokraus.fi/wp-content/uploads/2023/03/Fiksuvuokraus.fi_logo.png'
                      alt='Fiksuvuokraus.fi Logo'
                    />
                  </Typography>
                ) : pathname.includes('/tenants') ? (
                  <a href="https://fiksuvuokraus.fi" target="_blank" rel="noopener noreferrer">
                    <img
                      className={classes.logo}
                      style={{ color: '#fff', width: '100%' }}
                      src='https://fiksuvuokraus.fi/wp-content/uploads/2023/03/Fiksuvuokraus.fi_logo.png'
                      alt='Fiksuvuokraus.fi Logo'
                    />
                  </a>
                ) : (
                  <Link to='/'>
                    <img
                      className={classes.logo}
                      style={{ color: '#fff', width: '100%' }}
                      src='https://fiksuvuokraus.fi/wp-content/uploads/2023/03/Fiksuvuokraus.fi_logo.png'
                      alt='Fiksuvuokraus.fi Logo'
                    />
                  </Link>
                )}
                {!pathname.includes('/new-application') && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={phoneIcon}
                      style={{ width: '24px', height: '24px', marginRight: '5px', marginLeft: '20px' }}
                      alt="Phone Icon"
                    />
                    <a href="tel: 0406706816" style={{ textDecoration: 'none', color: 'inherit' }}>
                      +358406706816
                    </a>
                  </div>
                )}
                {/* {!isNewApplication(pathname) && isAuthenticated ? (
                  <NavBarPhoneNumber
                    {...{ isAuthenticated, smallScreen, classes, isTinyScreen }}
                  />
                ) : null} */}
              </Typography>
            </Grid>
            {/* {!isNewApplication(pathname) && !isAuthenticated ? (
              <NavBarPhoneNumber
                {...{ isAuthenticated, smallScreen, classes, isTinyScreen }}
              />
            ) : null} */}
            {isAuthenticated ? (
              smallScreen ? (
                <>
                  <Grid item xs={2} sm={1} className={classes.mobileMenu}>
                    <IconButton
                      color='inherit'
                      aria-label='open drawer'
                      onClick={() =>
                        !isNumStep(pathname, '10') && handleToggleDrawer()
                      }
                      className={classes.menuButton}
                    >
                      <MenuBarIcon
                        color='#fff'
                        style={{
                          opacity: isNumStep(pathname, '10') ? '0.6' : '1'
                        }}
                      />
                    </IconButton>
                  </Grid>
                </>
              ) : (
                <>
                  <DesktopMenu {...baseNavMenuProps} {...navMenuActionProps} />
                </>
              )
            ) : (
              showLanguageSwitcher && (
                <NavLanguageForm classes={classes} smallScreen={smallScreen} />
              )
            )}
          </Grid>
        </Toolbar>
      </AppBar>

      {smallScreen && isAuthenticated && (
        <NavDrawer
          {...baseNavMenuProps}
          {...navMenuActionProps}
          handleToggleDrawer={handleToggleDrawer}
          isOpen={drawerOpen}
        />
      )}
    </Fragment>
  )
}

export default NavBar
